import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import productService from '../../services/product.service';
import { useNavigate } from 'react-router-dom';
import './ViewProducts.css';

const ViewProducts = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  useEffect(() => {
    fetchProducts();
  }, [pagination.page, searchTerm]);

  const fetchProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const isAdminRole = ['SUPER_ADMIN', 'OFFICE_ADMIN'].includes(user?.role);

const companyId = isAdminRole
  ? localStorage.getItem('selectedCompanyId')
  : null;
        
      const response =  await productService.getAllProducts(1, 1000, '', companyId);

      if (response.success) {
        setProducts(response.data.products);
        setPagination(prev => ({
          ...prev,
          ...response.data.pagination,
        }));
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch products');
      console.error('Error fetching products:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddProduct = async (productData) => {
    try {
      const response = await productService.createProduct(productData);
      if (response.success) {
        fetchProducts(); // Refresh list
        alert('Product added successfully!');
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to add product');
      throw err;
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this product?')) {
      return;
    }

    try {
      const response = await productService.deleteProduct(id);
      if (response.success) {
        fetchProducts();
        alert('Product deleted successfully!');
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to delete product');
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  return (
    <div className="view-products-container">
      {/* Header */}
      <div className="products-header">
        <h4 className="products-title">View Products</h4>
      </div>

      {/* Search Bar */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search products by name, company, category..."
          className="search-input"
          value={searchTerm}
          onChange={handleSearch}
        />
        <span className="search-icon">🔍</span>
      </div>

      {/* Products Table */}
      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading products...</p>
        </div>
      ) : error ? (
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button className="btn-retry" onClick={fetchProducts}>
            Retry
          </button>
        </div>
      ) : products.length === 0 ? (
        <div className="empty-state">
          <p>No products found</p>
          <button onClick={() => navigate('/product/add')}>Add Product</button>
        </div>
      ) : (
        <>
          <div className="table-container">
            <table className="products-table">
              <thead>
                <tr>
                  <th>PRODUCT NAME</th>
                  <th>COMPANY</th>
                  <th>CATEGORY</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.id}>
                    <td>{product.productName}</td>
                    <td>{product.company?.name || '-'}</td>
                    <td>{product.category?.name || '-'}</td>
                    <td>
                      <div className="action-buttons">
                       <button className="btn-action btn-view" onClick={() => navigate(`/product/view/${product.id}`)}>view</button>
<button className="btn-action btn-edit" onClick={() => navigate(`/product/edit/${product.id}`)}>edit</button>
                        <button 
                          className="btn-action btn-delete"
                          onClick={() => handleDelete(product.id)}
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="pagination">
            <button
              className="pagination-btn"
              disabled={pagination.page === 1}
              onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
            >
              Previous
            </button>
            <span className="pagination-info">
              Page {pagination.page} of {pagination.totalPages} ({pagination.total} total)
            </span>
            <button
              className="pagination-btn"
              disabled={pagination.page >= pagination.totalPages}
              onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
            >
              Next
            </button>
          </div>
        </>
      )}

    </div>
  );
};

export default ViewProducts;